import vconst from 'utils/helpers/structs/vconst';

type ExpendTeamLike = {
    income_status?: number | string;
    income_count?: number;
    incomeCount?: number;
    income_price_sale?: number;
    incomePriceSale?: number;
};

type ObjectCardDataLike = {
    expendTeams?: ExpendTeamLike[] | null;
};

type ObjectInfoLike = {
    prodPriceSale?: number;
} | null;

/** Роздрібна вартість: списані товари + активні послуги об'єкта. */
export const getActualObjectCost = (
    vObject: ObjectCardDataLike | null | undefined,
    vObjectInfo: ObjectInfoLike,
): number => {
    const productsSale = Number(vObjectInfo?.prodPriceSale) || 0;

    let servicesSale = 0;
    vObject?.expendTeams?.forEach((expend) => {
        if (Number(expend.income_status) !== vconst.incomeStatActive) return;
        const count = Number(expend.income_count ?? expend.incomeCount ?? 1) || 1;
        const priceSale = Number(expend.income_price_sale ?? expend.incomePriceSale ?? 0);
        servicesSale += count * priceSale;
    });

    return Math.round((productsSale + servicesSale) * 100) / 100;
};
